// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"da70fa32","453":"eddd9176","667":"ac7ca001","977":"fbdf10d8"}[chunkId] + ".chunk.js";
};